export const themeMap = {
    light: '/light-theme.css',
    dark: '/dark-theme.css',
}

// Helpers
export function getBrowserColourScheme() {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}
